/*
 * Market/language stickiness v2.1 — 2026-07-24 (v2.1: obsługa jednoczłonowych prefiksów językowych rynku primary, np. /es; flaga świadomej zmiany lokalizacji przez sessionStorage)
 * Zastępuje custom-geolocalization.js (Piotr, 2025). Jedyna funkcja: pamiętaj ostatnio
 * używany rynek+język (prefiks URL, np. pl-pl, ja-jp) i po wejściu na stronę główną
 * bez prefiksu wróć do niego. Pierwszą wizytę (wykrycie kraju po IP + języka) obsługuje
 * NATYWNE automatyczne przekierowanie Shopify Markets — ten skrypt go nie dubluje.
 * Świadomy wybór rynku USA (primary, bez prefiksu) zapisuje 'primary' i wyłącza powrót.
 */
(function () {
  'use strict';
  try {
    if (/bot|crawl|spider|googlebot|bingbot|yandex|baidu|duckduck|slurp|petalbot/i.test(navigator.userAgent)) return;

    var KEY = 'preferredLocale';
    var PREFIX_RE = /^\/([a-z]{2}(?:-[a-z]{2})?)(?=\/|$)/; // xx-yy (rynki) LUB samo xx (języki rynku primary, np. /es)
    var path = window.location.pathname;
    var match = path.match(PREFIX_RE);

    // Lądowanie PO świadomej zmianie w selektorze: brak prefiksu => wybrano primary (angielski US).
    var deliberate = null;
    try { deliberate = sessionStorage.getItem('mwLocSwitch'); sessionStorage.removeItem('mwLocSwitch'); } catch (e) { /* noop */ }
    if (deliberate && !match) {
      try { localStorage.setItem(KEY, 'primary'); } catch (e) { /* noop */ }
    }

    if (match) {
      // Każda strona rynku z prefiksem = aktualna preferencja (rynek + język).
      try { localStorage.setItem(KEY, match[1]); } catch (e) { /* storage niedostępny */ }
    } else if (path === '/' || path === '') {
      // Strona główna bez prefiksu: wróć do zapamiętanego rynku (o ile nie wybrano USA).
      var saved = null;
      try { saved = localStorage.getItem(KEY); } catch (e) { /* storage niedostępny */ }
      if (saved && saved !== 'primary' && /^[a-z]{2}(?:-[a-z]{2})?$/.test(saved)) {
        window.location.replace('/' + saved + window.location.search + window.location.hash);
        return;
      }
    }

    // Świadomy wybór rynku USA w selektorze => zapamiętaj 'primary' (strony US nie mają
    // prefiksu, więc bez tego zapisu powrót na root odsyłałby do starego rynku).
    // UWAGA: głównym mechanizmem jest listener CLICK — ten theme wybiera kraj przez
    // programowe form.submit(), które NIE emituje zdarzenia 'submit'. Listener submit
    // zostaje jako zabezpieczenie na wypadek przejścia theme na requestSubmit()/select.
    // Nie usuwać clicka w refaktorze w przekonaniu, że submit wystarczy!
    function rememberPrimary() {
      try { localStorage.setItem(KEY, 'primary'); } catch (e) { /* noop */ }
    }
    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form || !form.getAttribute) return;
      var action = form.getAttribute('action') || '';
      if (action.indexOf('/localization') === -1) return;
      var cc = form.querySelector('input[name="country_code"], select[name="country_code"]');
      if (cc && String(cc.value).toUpperCase() === 'US') rememberPrimary();
    }, true);
    document.addEventListener('click', function (e) {
      if (!e.target || !e.target.closest) return;
      if (e.target.closest('localization-form a[data-value="US"]')) rememberPrimary();
      // KAŻDA interakcja z selektorem kraju/języka => flaga "świadoma zmiana" na czas nawigacji.
      // Jeśli strona docelowa NIE ma prefiksu (angielski rynku primary), zapisujemy 'primary' —
      // bez tego przełączenie /es -> English odbijałoby klienta z powrotem na /es.
      if (e.target.closest('localization-form a[data-value]')) {
        try { sessionStorage.setItem('mwLocSwitch', '1'); } catch (err) { /* noop */ }
      }
    }, true);
  } catch (err) { /* nigdy nie psuj strony */ }
})();
